export class TipoObrigacao {
  ativo: boolean;
  id: number;
  titulo: string;
  descricao: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/shared/obrigacao-tipo.model.ts
 **/